// import { gql } from "@apollo/client"
import gql from "graphql-tag"
export const CREATE_BOOKER = gql`
    mutation CreateBooker($newBookerData: BookerInput!) {
        createBooker(newBookerData: $newBookerData) {
            id
            gender
            firstname
            lastname
            street
            houseNumber
            postCode
            city
            phoneNumber
            mobileNumber
            email
            birthday
            initialContact
            dsgvo
            newsletter
            healthInsuranceFund
            annotation
            paymentMethods {
                id
                cash
                creditCardAccountholder
                creditcardNumber
                expirationDate
                validFrom
                cvc
                paypalAccountholder
                email
                iban
                bank
                bic
                sepaAccountholder
                type
            }
            attendees {
                id
                customer {
                    id
                }
                gender
                lastname
                firstname
                birthday
                member
                defaultPaymentMethod {
                    id
                }
                bookings {
                    id
                    courseId
                    bookingNumberPrefix
                    canceled
                    courseLessons {
                        id
                    }
                    paymentMethod {
                        id
                    }
                    paymentType
                    payDate
                }
            }
        }
    }
`

export const UPDATE_BOOKER = gql`
    mutation UpdateBooker($updateBookerData: BookerInput!, $fromEndUserApp: Boolean!) {
        updateBooker(updateBookerData: $updateBookerData, fromEndUserApp: $fromEndUserApp) {
            id
            gender
            firstname
            lastname
            street
            houseNumber
            postCode
            city
            phoneNumber
            mobileNumber
            email
            birthday
            initialContact
            dsgvo
            newsletter
            healthInsuranceFund
            annotation
            paymentMethods {
                id
                cash
                creditCardAccountholder
                creditcardNumber
                expirationDate
                validFrom
                cvc
                paypalAccountholder
                email
                iban
                bank
                bic
                sepaAccountholder
                type
            }
            attendees {
                id
                customer {
                    id
                }
                gender
                lastname
                firstname
                birthday
                member
                deletable
                startedCourses {
                    id
                    prefixedCourseNumber
                }
                defaultPaymentMethod {
                    id
                }
                bookings {
                    id
                    courseId
                    bookingNumberPrefix
                    canceled
                    courseLessons {
                        id
                    }
                    paymentMethod {
                        id
                    }
                    paymentType
                    payDate
                }
            }
            userId
        }
    }
`

export const GET_UPDATED_BOOKER = gql`
    query GetUpdatedBooker($id: String!) {
        booker(id: $id) {
            id
            firstname
            lastname
            gender
            createDate
            updateDate
            customerId
            addition
            street
            houseNumber
            postCode
            city
            phoneNumber
            mobileNumber
            email
            birthday
            credit
            initialContact
            dsgvo
            newsletter
            customer {
                id
            }
            paymentMethods {
                id
                cash
                creditCardAccountholder
                creditcardNumber
                expirationDate
                validFrom
                cvc
                paypalAccountholder
                email
                iban
                bank
                bic
                sepaAccountholder
                bankTransfer
                esr
                type
            }
            attendees {
                id
                customer {
                    id
                }
                gender
                lastname
                firstname
                birthday
                member
                deletable
                defaultPaymentMethod {
                    id
                }
                bookings {
                    id
                    courseId
                    bookingNumberPrefix
                    canceled
                    courseLessons {
                        id
                    }
                    paymentMethod {
                        id
                    }
                    paymentType
                    payDate
                }
            }
            healthInsuranceFund
            annotation
            createdBy
            userId
        }
    }
`

export const DELETE_ATTENDEE = gql`
    mutation DeleteAttendee($id: String!) {
        deleteAttendee(id: $id)
    }
`

export const BOOK_PAYMENT_METHOD_LOCAL_STATE = gql`
    query bookPaymentMethodGetLocalState {
        LocalState @client {
            bookPaymentMethods {
                selectedPaymentMethod {
                    id
                    type
                    bookedCourseIds
                }
                selectedCourseId
            }
        }
    }
`

export const GET_COURSE_LESSON_START_DATES = gql`
    query GetCourseLessonStartDates($ids: [String!]) {
        courseLessons(ids: $ids) {
            id
            startDateTime
            course {
                id
                prefixedCourseNumber
            }
        }
    }
`

export const UPDATE_BOOKER_ACCOUNT_ENDUSERAPP = gql`
    mutation UpdateBookerAccountEndUserApp(
        $updateBookerEndUserAppData: UpdateBookerAccountEndUserAppInput!
        $fromEndUserApp: Boolean!
    ) {
        updateBookerAccountEndUserApp(
            updateBookerEndUserAppData: $updateBookerEndUserAppData
            fromEndUserApp: $fromEndUserApp
        ) {
            id
            gender
            firstname
            lastname
            birthday
            street
            postCode
            city
            mobileNumber
            phoneNumber
            dsgvo
            newsletter
            email
            paymentMethods {
                id
                type
                iban
                bank
                bic
                sepaAccountholder
            }
        }
    }
`

export const ADD_BOOKER_AS_ATTENDEE = gql`
    mutation AddBookerAsAttendee($bookerId: ID!) {
        addBookerAsAttendee(bookerId: $bookerId) {
            id
            customerId
            firstname
            lastname
            birthday
            gender
            attendees {
                id
                customerId
                customer {
                    firstname
                    lastname
                    gender
                }
                birthday
                defaultPaymentMethodId
            }
        }
    }
`

export const BOOKER_EXISTS_AS_ATTENDEE_ENDUSERAPP = gql`
    query BookerExistsAsAttendeeEndUserApp($bookerId: ID!) {
        bookerExistsAsAttendeeEndUserApp(bookerId: $bookerId)
    }
`
